import React from "react";

/**
 * Arc-style Loading spinner
 * Uses dynamic accent color from workspace theme
 */
const Loading: React.FC<{ size?: number }> = ({ size = 64 }) => {
  return (
    <div className="flex items-center justify-center">
      <div
        className="animate-spin rounded-full border-4 border-accent border-t-transparent"
        style={{ width: size, height: size }}
      />
    </div>
  );
};

/**
 * Dot-style loading animation
 * Uses accent color by default, can be overridden with color prop
 */
const LoadingDot: React.FC<{ color?: string; useAccent?: boolean }> = ({ 
  color, 
  useAccent = true 
}) => {
  // Use CSS variable for accent color if useAccent is true and no color is provided
  const dotStyle = color 
    ? { backgroundColor: color } 
    : useAccent 
      ? { backgroundColor: "var(--arc-accent)" } 
      : { backgroundColor: "#fff" };

  return (
    <div className="inline-block relative w-20 h-20">
      <div
        className="top-[33px] w-[13px] h-[13px] rounded-full absolute left-[8px] animate-loadingDot1"
        style={dotStyle}
      />
      <div
        className="top-[33px] w-[13px] h-[13px] rounded-full absolute left-[8px] animate-loadingDot2"
        style={dotStyle}
      />
      <div
        className="top-[33px] w-[13px] h-[13px] rounded-full absolute left-[32px] animate-loadingDot2"
        style={dotStyle}
      />
      <div
        className="top-[33px] w-[13px] h-[13px] rounded-full absolute left-[56px] animate-loadingDot3"
        style={dotStyle}
      />
    </div>
  );
};

/**
 * Circular loading animation
 * Uses dynamic accent color from workspace theme
 */
const LoadingCircular: React.FC<{ scale?: number }> = ({ scale = 1 }) => {
  return (
    <div
      className="text-accent text-[10px] w-[1em] h-[1em] rounded-full relative indent-[-9999em] animate-mulShdSpin transform translate-x-[-50%] translate-y-[-50%]"
      style={{ transform: `scale(${scale})` }}
    />
  );
};

export default Loading;
export { Loading, LoadingCircular, LoadingDot };
